// extracted by mini-css-extract-plugin
module.exports = {"link":"bd62d24d75759a819e7f4040b4d7ab54"};